import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Anchor.module.css';

export type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  size?: 'xs' | 'sm' | 'md';
  children: ReactNode;
};

export function Anchor({ size = 'sm', className, children, ...rest }: AnchorProps) {
  return (
    <a className={cx(styles.anchor, styles[`size_${size}`], className)} {...rest}>
      {children}
    </a>
  );
}
